export default __webpack_public_path__ + "static/media/make-move.c34789bc.wav";